module.exports = __webpack_public_path__ + "static/img/introduceB1.56b1f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceB1.png
// module id = 0BkK
// module chunks = 0